const menu = {
    profile: 'Hồ sơ',
    language: 'Ngôn ngữ',
    appearance: {
        label: 'Giao diện',
        light: 'Chế độ sáng',
        dark: 'Chế độ tối',
        system: 'Đồng bộ theo hệ thống',
    },
    sign_out: 'Đăng xuất',
};
export default Object.freeze(menu);
